import { IResponseList } from '@/types/common';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';
import { IGetListTagResponse } from '@/types/response/tag';

class Tag {
  getList = (type?: string): Promise<IResponseList<IGetListTagResponse>> => {
    return axiosClient.get(ENDPOINT.TAG.GET_LIST, {
      params: type ? { type } : undefined,
    });
  };
}

export const TagService = new Tag();
